import open from "webmodals/open";
import controller from "emun.cart/cart-item-cancel-date.controller";
import templateUrl from "emun.cart/cart-item-cancel-date.htm";

export default ({
  size = "md",
  backdrop = "static",
  placement = "center",
  preventAutoHeight = true,
  cartItem = {},
  product = cartItem.product,
  title = product ? `Select Cancel Date for ${product.id}` : 'Select Cancel Date'
}) =>
  open({
    size,
    backdrop,
    templateUrl,
    placement,
    controller,
    resolve: {
      preventAutoHeight: () => preventAutoHeight,
      title: () => title,
      cartItem: () => cartItem,
      product: () => product
    },
    bindToController: true,
    controllerAs: "$ctrl"
  }).result;
